export const ARTICLES = [
  {
    slug: 'comment-utiliser-vwap-ninjatrader-8',
    title: {
      fr: 'Comment utiliser le VWAP sur NinjaTrader 8',
      en: 'How to use VWAP on NinjaTrader 8',
    },
    summary: {
      fr: 'Prix moyen pondéré par le volume : benchmark, biais de séance, bounce et VWAP ancré.',
      en: 'Volume-weighted average price: session benchmark, bias, bounce, and anchored VWAP.',
    },
    description: {
      fr: 'Le VWAP, c’est le prix moyen de la séance pondéré par le volume : benchmark, biais, bandes. Bounce, reclaim, extension, VWAP ancré.',
      en: 'VWAP is the session’s volume-weighted average price: benchmark, bias, bands. Bounce, reclaim, extension, anchored VWAP.',
    },
  },
  {
    slug: 'volume-profile-guide-traders-futures',
    title: {
      fr: 'Volume Profile : guide pour traders futures',
      en: 'Volume Profile: a guide for futures traders',
    },
    summary: {
      fr: 'Où le volume s’est échangé : POC, value area, rotation ou breakout.',
      en: 'Where volume actually traded: POC, value area, rotation or breakout.',
    },
    description: {
      fr: 'Un Volume Profile montre où le volume s’est échangé : POC, value area, zones denses ou vides. Rotation ou breakout.',
      en: 'A Volume Profile shows where volume traded: POC, value area, dense or empty zones. Rotation or breakout.',
    },
  },
  {
    slug: 'sessions-trading-tokyo-londres-new-york',
    title: {
      fr: 'Sessions de trading : Tokyo, Londres, New York',
      en: 'Trading sessions: Tokyo, London, New York',
    },
    summary: {
      fr: 'Handoff Asie → Londres → New York, et les high/low overnight comme contexte.',
      en: 'Asia → London → New York handoff, and overnight highs and lows as context.',
    },
    description: {
      fr: 'Pourquoi les futures tournent sur trois places : handoff Asie → Londres → New York, overnight high/low comme contexte.',
      en: 'Why futures trade across three venues: Asia → London → New York handoff, overnight high/low as context.',
    },
  },
  {
    slug: 'opening-range-breakout-ninjatrader',
    title: {
      fr: 'Opening Range : breakout, fade, et différence avec l’Initial Balance',
      en: 'Opening Range: breakout, fade, and how it differs from Initial Balance',
    },
    summary: {
      fr: 'Le premier cadre après l’open : cassure, fade, et ce que l’IB n’est pas.',
      en: 'The first frame after the open: breakout, fade, and what IB is not.',
    },
    description: {
      fr: 'L’opening range, c’est le premier cadre après l’open. Breakout ou fade, OR versus IB.',
      en: 'The opening range is the first frame after the open. Breakout or fade, OR versus IB.',
    },
  },
  {
    slug: 'gerer-risque-prop-firm-account-locker',
    title: {
      fr: 'Gérer son risque en prop firm : voir le compte, le bloquer, suivre le drawdown',
      en: 'Managing prop-firm risk: see the account, lock it, track drawdown',
    },
    summary: {
      fr: 'Daily loss, drawdown et lock : protéger l’évaluation, pas seulement le trade.',
      en: 'Daily loss, drawdown, and lock: protect the evaluation, not just the trade.',
    },
    description: {
      fr: 'En prop firm, le risque n’est pas théorique : un jour de trop et l’évaluation tombe. Voir le PnL, suivre le drawdown, bloquer le compte.',
      en: 'In a prop firm, risk is not theoretical: one extra day and the evaluation is gone. See PnL, track drawdown, lock the account.',
    },
  },
  {
    slug: 'annonces-economiques-proteger-son-compte',
    title: {
      fr: 'Annonces économiques : l’impact sur les marchés, et comment ne pas tuer son compte',
      en: 'Economic announcements: market impact, and how not to kill the account',
    },
    summary: {
      fr: 'NFP, CPI, FOMC : l’heure compte plus que le sens. Rester plat, protéger le daily.',
      en: 'NFP, CPI, FOMC: the clock matters more than the direction. Stay flat, protect the daily.',
    },
    description: {
      fr: 'NFP, CPI, FOMC : le marché sait l’heure, pas le sens. Voir les news, rester plat, protéger le compte.',
      en: 'NFP, CPI, FOMC: the market knows the time, not the direction. See the news, stay flat, protect the account.',
    },
  },
  {
    slug: 'lire-un-footprint-order-flow',
    title: {
      fr: 'Lire un footprint : cellules Bid × Ask, imbalance, absorption',
      en: 'Reading a footprint: Bid × Ask cells, imbalance, absorption',
    },
    summary: {
      fr: 'L’intérieur de la barre : Bid × Ask, imbalance, absorption — et les pièges.',
      en: 'Inside the bar: Bid × Ask, imbalance, absorption — and the traps.',
    },
    description: {
      fr: 'Un footprint montre qui a été agressif à chaque prix, dans chaque barre. Cellule, imbalance, absorption — et les pièges.',
      en: 'A footprint shows who was aggressive at each price, in each bar. Cell, imbalance, absorption — and the traps.',
    },
  },
  {
    slug: 'cumulative-delta-pression-acheteur-vendeur',
    title: {
      fr: 'Cumulative Delta : la pression acheteur / vendeur dans le temps — et où elle s’est dépensée',
      en: 'Cumulative Delta: buyer / seller pressure over time — and where it was spent',
    },
    summary: {
      fr: 'Pression dans le temps versus profil de delta : où elle s’est dépensée.',
      en: 'Pressure over time versus a delta profile: where it was spent.',
    },
    description: {
      fr: 'Le Cumulative Delta montre la pression agressive au fil de la séance. Le profil de delta montre à quels prix. Une divergence n’est pas un retournement.',
      en: 'Cumulative Delta shows aggressive pressure through the session. A delta profile shows at which prices. A divergence is not a reversal.',
    },
  },
];

export const ARTICLE_SLUGS = ARTICLES.map((article) => article.slug);

export function getArticleBySlug(slug) {
  return ARTICLES.find((article) => article.slug === slug) || null;
}

export function articleLanguage(language) {
  return String(language || 'fr').startsWith('en') ? 'en' : 'fr';
}

export function getArticleCopy(article, language) {
  const lang = articleLanguage(language);
  return {
    title: article.title[lang],
    summary: article.summary[lang],
    description: article.description[lang],
  };
}
